'use client';
import { useState } from 'react';

export interface Citation {
  snippet?: string;
  score?: number;
  source?:
    | string
    | {
        document?: string;
        page?: number;
        knowledgeBase?: string;
        headings?: string[] | null;
      };
}

interface CitationChipProps {
  citation: Citation;
}

export default function CitationChip({ citation }: CitationChipProps) {
  const [open, setOpen] = useState(false);
  const doc =
    typeof citation.source === 'string'
      ? citation.source
      : (citation.source?.document ?? 'source');
  const page =
    typeof citation.source === 'object' && citation.source !== null
      ? citation.source.page
      : undefined;
  return (
    <div
      className="mobeus-citation-chip" part="citation-chip"
      style={{
        display: 'inline-block',
        margin: '4px 4px 4px 0',
        padding: '2px 8px',
        borderRadius: 12,
        background: 'var(--mobeus-chip-bg, #dbeafe)',
        border: '1px solid var(--mobeus-chip-border, #93c5fd)',
        fontSize: 11,
        fontFamily: 'var(--mobeus-font, system-ui, sans-serif)',
        color: 'var(--mobeus-chip-text, #1e40af)',
        cursor: 'pointer',
      }}
      onClick={() => setOpen((v) => !v)}
    >
      <span aria-hidden="true">[doc]</span> {doc}
      {page !== undefined ? `:${page}` : ''}
      {open && citation.snippet && (
        <div
          style={{
            marginTop: 4,
            padding: 6,
            background: 'var(--mobeus-surface, #fff)',
            border: '1px solid var(--mobeus-border, #e5e7eb)',
            borderRadius: 4,
            fontSize: 11,
            color: 'var(--mobeus-text-muted, #374151)',
            maxWidth: 320,
            whiteSpace: 'normal',
          }}
        >
          {citation.snippet}
        </div>
      )}
    </div>
  );
}
